import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'user/roles' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
